/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React, {useState} from 'react';

/**
 * @hook useToggleToolTip
 *
 * Provides a utility hook for showing the tooltip during onclick.
 *
 * ```typescript
 *
 *  import {useToggleToolTip} from '@ion/dls/src/hooks/useToggleToolTip';
 *
 *  const [tooltipId, toggleToolTip]= useToggleToolTip(null);
 *
 *   const SomeComponent = () => {
 *     <IconCustomTooltip id='chat'>
 *         <div onClick={function(e) { toggleToolTip('chat'); }}>
 *          <IconButton color='inherit'
 *             icon={<TopNavChatIcon />} />
 *         </div>
 *       </IconCustomTooltip>
 *   }
 *
 * ```
 */
export const useToggleToolTip= (id) => {
  const [tooltipId, toggleToolTip] = useState(id);
  function toggle(id) {
    toggleToolTip(id);
  };

  return [tooltipId, toggleToolTip];
};

export default useToggleToolTip;
